import React, { FunctionComponent, useEffect, useRef, useContext } from 'react';
import { Player } from 'components/Player';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { useAudio } from 'features/audio/audio';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { useLocation } from 'react-router-dom';

export const EventPlayer: FunctionComponent = () => {
  const { isNativeAppWebview } = useContext(UserAgentContext);
  const audioUrl = useSelector((state: RootState) => state.audio.url);
  const playing = useSelector((state: RootState) => state.audio.playing);
  const { audio, loadAudio, play, stop } = useAudio();
  const location = useLocation() as any;
  const hasLoadededAudio = useRef<boolean>(false);

  useEffect(() => {
    if (hasLoadededAudio.current || isNativeAppWebview) return;
    if (location.state && location.state.autoPlay && audioUrl) {
      loadAudio({
        audioSrc: audioUrl,
        autoPlay: true,
        audioType: 'event'
      });
      hasLoadededAudio.current = true;
    }
  }, [location, audioUrl, loadAudio, isNativeAppWebview]);

  if (!audioUrl) {
    return null;
  }

  if (isNativeAppWebview) {
    return null;
  }

  const onClick = () => {
    if (audio) {
      if (playing) {
        stop();
      } else {
        play();
      }
    } else {
      loadAudio({
        audioSrc: audioUrl,
        autoPlay: true,
        audioType: 'event'
      });
    }
  };

  return <Player onClick={onClick} type={'event'} />;
};
